import React from "react";

const ProductImageCard = ({ src, alt, className }) => {
  return (
    <img
      key={src}
      src={src}
      draggable={false}
      onContextMenu={(e) => e.preventDefault()}
      className={className}
      alt={alt || "Product preview"}
    />
  );
};

export default ProductImageCard;
